/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PermissionFilterRequest
 */
export interface PermissionFilterRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PermissionFilterRequest
     */
    includeGlobalValues?: boolean;
    /**
     * 
     * @type {Array<any>}
     * @memberof PermissionFilterRequest
     */
    permissionIds?: Array<any> | null;
}

/**
 * Check if a given object implements the PermissionFilterRequest interface.
 */
export function instanceOfPermissionFilterRequest(value: object): value is PermissionFilterRequest {
    return true;
}

export function PermissionFilterRequestFromJSON(json: any): PermissionFilterRequest {
    return PermissionFilterRequestFromJSONTyped(json, false);
}

export function PermissionFilterRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionFilterRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'includeGlobalValues': json['includeGlobalValues'] == null ? undefined : json['includeGlobalValues'],
        'permissionIds': json['permissionIds'] === undefined ? undefined : json['permissionIds'] === null ? null : json['permissionIds'],
    };
}

export function PermissionFilterRequestToJSON(json: any): PermissionFilterRequest {
    return PermissionFilterRequestToJSONTyped(json, false);
}

export function PermissionFilterRequestToJSONTyped(value?: PermissionFilterRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'includeGlobalValues': value['includeGlobalValues'],
        'permissionIds': value['permissionIds'],
    };
}

